import React, { useState, useEffect } from "react";
import moment from 'moment';
import { Row, Col, Table, Tooltip, Button, Divider } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

import { FormatNumber } from '../../../ValueObjects';

export default function FormaPagamento({ formaPagamento }) {
    const expandedRowRender = record => {
        return <Table dataSource={record.parcelas} columns={
            [
                {
                    title: '',
                    render: ({ prc_numeroparcela, prc_datavencimento, prc_valor }) => (
                        <div>
                            <Row align="middle" justify="space-between" gutter={[8, 0]}>
                                <Col>
                                    Nº: <b>{prc_numeroparcela}</b>
                                </Col>
                                <Col>
                                    Vencimento: <b>{!!prc_datavencimento ? moment(prc_datavencimento).format('DD/MM/YYYY') : null}</b>
                                </Col>
                                <Col>
                                    Valor (R$): <b>{FormatNumber(!!prc_valor ? prc_valor : 0, true)}</b>
                                </Col>
                            </Row>
                        </div>
                    ),
                },
            ]
        } pagination={false} />
    };

    const rowExpandable = record => { return record.fpg_tipopagamento === 5 };

    return (
        <div className="tabela modalTable">
            <Table dataSource={formaPagamento} showHeader={true} columns={
                [
                    {
                        title: 'Forma/Condição Pagto',
                        render: ({ fpg_descricao, cpg_descricao }) => (
                            <div>
                                <Row align="middle" justify="space-between" gutter={[8, 0]}>
                                    <Col span={16}>
                                        <b>{fpg_descricao + (!!cpg_descricao ? '/ ' + cpg_descricao : '')}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'NSU / Id Integração',
                        align: 'center',
                        width: 75,
                        render: ({ imp_autorizacao, imp_idintegracao }) => (
                            <div>
                                {imp_autorizacao !== null && imp_autorizacao !== undefined && (
                                    <b>{imp_autorizacao + ' / ' + imp_idintegracao}</b>
                                )}
                            </div>
                        ),
                    },
                    {
                        title: 'Valor Troco',
                        align: 'right',
                        width: 150,
                        render: ({ nfp_valortroco }) => (
                            <div>
                                <b>R$ {FormatNumber(!!nfp_valortroco ? nfp_valortroco : 0, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Valor Líquido',
                        align: 'right',
                        width: 150,
                        render: ({ nfp_valor, nfp_valortroco }) => (
                            <div>
                                <b>R$ {FormatNumber(!!nfp_valor ? (nfp_valor - nfp_valortroco) : 0, true)}</b>
                            </div>
                        ),
                    },
                ]
            } pagination={false} expandable={{ expandedRowRender, rowExpandable }} />

        </div >
    );
}